import { Reducer } from "redux";
import { AppContextActions } from "./actions";
import { AppContextState, appContextState } from "./state";

export const appContextReducer: Reducer<AppContextState, AppContextActions.Actions> = (
  state = appContextState,
  action
) => {
  switch (action.type) {
    case AppContextActions.ActionTypes.SET_LANGUAGE: {
      return { ...state, language: action.payload.language };
    }
    default:
      return state;
  }
};
